/*
 * Copyright 2017-present Evernote Corporation. All rights reserved.
 */

export default {
  SIBLING_SEPARATOR: ',',
  CHILD_SEPARATOR: '.',
};
